import { Component } from '@angular/core';
import { IonicPage, LoadingController, ActionSheetController, PopoverController, ToastController, NavController } from 'ionic-angular';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { NgForm } from '@angular/forms/src/directives/ng_form';
import { PaginaBasica } from '../../models/PaginaBase';
import { APIOnLine } from '../../services/api/api.services';
import { Proxy } from '../../services/proxy/proxy.service';
import { Online } from '../../models/online/cfutbol';

@IonicPage()
@Component({
  selector: 'page-asistentes',
  templateUrl: 'asistentes.html',
})
export class AsistentesPage extends PaginaBasica {

  // #region Propiedades de la página
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  //#endregion

  // #region Visualización de asistentes
  public arbitro2: Online.IArbitro;
  public asistente1: Online.IArbitro;
  public asistente2: Online.IArbitro;
  public asistente3: Online.IArbitro;
  public asistente4: Online.IArbitro;
  public cronometrador: Online.IArbitro;
  // #endregion

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    public NavController: NavController,
    public popOverCtrl: PopoverController,
    public Persistentes: APIOnLine.Persistentes,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidLoad() {
    console.log('--- ENTRO EN LA PÁGINA : Cambio de los asistentes ---');
    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();

    console.log(this.designacion.Configuracion);

    if (this.designacion.Configuracion.nArbitros > 1) {
      this.CFutbolActas.arbitroPorDesignacionYFuncion(this.designacion.urlApi, this.designacion.idDesignacion, "ARBITRO2")
        .then((resultado: Online.IArbitro) => {
          if (resultado != null) {
            this.arbitro2 = resultado;
          }
          else{
            this.arbitro2 = this.InicializarArbitro();
          }
        })
        .catch((error) => this.Error(error, "Obteniendo los datos del árbitro 2"));
    }
    if (this.designacion.Configuracion.nAsistentes > 0) {
      this.CFutbolActas.arbitroPorDesignacionYFuncion(this.designacion.urlApi, this.designacion.idDesignacion, "ASISTENTE1")
        .then((resultado: Online.IArbitro) => {
          if (resultado != null) {
            this.asistente1 = resultado;
            console.log(this.asistente1);
          }
          else {
            this.asistente1 = this.InicializarArbitro();
          }
        })
        .catch((error) => this.Error(error, "Obteniendo los datos del asistente 1"));
    }
    if (this.designacion.Configuracion.nAsistentes > 1) {
      this.CFutbolActas.arbitroPorDesignacionYFuncion(this.designacion.urlApi, this.designacion.idDesignacion, "ASISTENTE2")
        .then((resultado: Online.IArbitro) => {
          if (resultado != null) {
            this.asistente2 = resultado;
          }
          else{
            this.asistente2 = this.InicializarArbitro();
          }
        })
        .catch((error) => this.Error(error, "Obteniendo los datos del asistente 2"));
    }
    if (this.designacion.Configuracion.nAsistentes > 2) {
      this.CFutbolActas.arbitroPorDesignacionYFuncion(this.designacion.urlApi, this.designacion.idDesignacion, "ASISTENTE3")
        .then((resultado: Online.IArbitro) => {
          if (resultado != null) {
            this.asistente3 = resultado;
          }
          else{
            this.asistente3 = this.InicializarArbitro();
          }
        })
        .catch((error) => this.Error(error, "Obteniendo los datos del asistente 3"));
    }
    if (this.designacion.Configuracion.nAsistentes > 3) {
      this.CFutbolActas.arbitroPorDesignacionYFuncion(this.designacion.urlApi, this.designacion.idDesignacion, "ASISTENTE4")
        .then((resultado: Online.IArbitro) => {
          if (resultado != null) {
            this.asistente4 = resultado;
          }
          else{
            this.asistente4 = this.InicializarArbitro();
          }
        })
        .catch((error) => this.Error(error, "Obteniendo los datos del asistente 4"));
    }
    if (this.designacion.Configuracion.cronometrador) {
      this.CFutbolActas.arbitroPorDesignacionYFuncion(this.designacion.urlApi, this.designacion.idDesignacion, "CRONOMETRADOR")
        .then((resultado: Online.IArbitro) => {
          if (resultado != null) {
            this.cronometrador = resultado;
          }
          else{
            this.cronometrador = this.InicializarArbitro();
          }
        })
        .catch((error) => this.Error(error, "Obteniendo los datos del cronometrador"));
    }
  }

  //#region Métodos del controlador

  /**
   * Realiza la actualización de los datos de los árbitros asociados con la designación actual
   * @param form Datos del formulario
   */
  public ActualizarArbitros(form: NgForm): void {
    if (form.valid) {
      this.MostrarOcultarCarga(false, "..actualizando colegiados ...");

      this.designacion.ActualizarArbitros(this.designacion.Configuracion.nArbitros > 1 ? this.arbitro2.numero : 0,
        this.designacion.Configuracion.nAsistentes > 0 ? this.asistente1.numero : 0,
        this.designacion.Configuracion.nAsistentes > 1 ? this.asistente2.numero : 0,
        this.designacion.Configuracion.nAsistentes > 2 ? this.asistente3.numero : 0,
        this.designacion.Configuracion.nAsistentes > 3 ? this.asistente4.numero : 0,
        this.designacion.Configuracion.cronometrador ? this.cronometrador.numero : 0)
        .then((resultado: Proxy.PrDesignaciones) => {
          this.designacion = resultado;
          this.MostrarOcultarCarga(true);

          this.Mensaje("Se han actualizado correctamente los colegiados.", 5000);
        })
        .catch((error) => this.Error(error, "Actualizando los colegiados de la designación."));
    }
  }

  public Atras(): void {
    this.NavController.pop();
  }

  public InicializarArbitro():Online.IArbitro{
    return {
      activo: true,
      apellido1: "",
      apellido2: "",
      contrasenia: "",
      firma: "",
      idArbitro: 0,
      nombre: "",
      numero: 0,
      usuario: ""
    };
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/asistentes/asistentes.ts